<template>
  <div class="modal">
    <slot />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      activeModal: 'modal/activeModal',
    }),
    name () {
      return this.$slots.default[0].context.$options.name
    },
  },
  mounted () {
    document.addEventListener('keydown', this.handleCloseModal)
  },
  destroyed () {
    document.removeEventListener('keydown', this.handleCloseModal)
  },
  methods: {
    handleCloseModal (e) {
      if (e.keyCode === 27) {
        this.closeModal()
      }
    },
    closeModal () {
      this.$store.dispatch('modal/close')
    },
  },
}
</script>
